import type { FinanceData } from "@/finance/data";
import type { BudgetDatabase } from "./db";

/** Loads everything the calculation layer needs. Personal-scale data fits comfortably in memory. */
export async function loadFinanceData(db: BudgetDatabase): Promise<FinanceData> {
  const [groups, categories, expenses, incomes, budgets, incomeBudgets, anchors] = await Promise.all([
    db.categoryGroups.toArray(),
    db.categories.toArray(),
    db.expenses.toArray(),
    db.incomes.toArray(),
    db.budgets.toArray(),
    db.incomeBudgets.toArray(),
    db.balanceAnchors.toArray(),
  ]);
  return { groups, categories, expenses, incomes, budgets, incomeBudgets, anchors };
}
